import * as shp from 'shpjs';

import M from 'utils/ApiCNIG';
import Utils from 'utils/Utils';
import ClipInteraction from 'utils/ClipInteraction';

const EDITION_COLOR = '#FFCC33';
const PROJECTION = 'EPSG:25830';
const CENTER = [702851.1093967422, 4583909.333604186];
declare var ol;
declare var loadshp;
declare var CONFIGURATIONS;

export let mapjs;
export let mapInfojs;
let moveEndEvent;

export const initMap = (flight, features, fullFeatures, updateFeatures, unblock, t) => {
	let initZoom = 5.8;
	if (window.innerHeight <= 907 && window.innerHeight >= 703) {
		initZoom = 5.4;
	} else if (window.innerHeight <= 702 && window.innerHeight > 620) {
		initZoom = 5.2;
	} else if (window.innerHeight <= 620 && window.innerHeight > 550) {
		initZoom = 5;
	} else if (window.innerHeight <= 550 && window.innerHeight > 485) {
		initZoom = 4.8;
	} else if (window.innerHeight <= 485 && window.innerHeight >= 485) {
		initZoom = 4.6;
	}

	mapjs = M.map({
		container: 'map',
		controls: ['scaleline'],
		projection: `${PROJECTION}*m`,
		center: CENTER,
		zoom: initZoom,
		minZoom: initZoom,
		zoomConstrains: false,
	});

  window.mapjs = mapjs;
  mapjs.getMapImpl().on('click', (evt) => {
    removeMapOverlays();
    if (flight() !== undefined) {
      mapjs.getMapImpl().forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        let newSelected = [].concat(features());
        let newFullSelected = [].concat(fullFeatures());
        if (layer !== null && Utils.stringContainsString(feature.getGeometry().getType(), 'Point') && feature.getProperties()[CONFIGURATIONS.fotogram_attr] !== undefined) {
          const ID = feature.getProperties()[CONFIGURATIONS.fotogram_attr];
          if (newSelected.indexOf(ID) < 0) {
            newSelected.push(ID);
            newFullSelected.push({ properties: feature.getProperties() });
          } else {
            newSelected = [].concat(newSelected.filter((item) => {
              if (item === ID) {
                removeCustomWMSLayer(feature.getProperties().layer_id);
              }

              return item !== ID;
            }));

            newFullSelected = [].concat(newFullSelected.filter((item) => {
              return item.properties[CONFIGURATIONS.fotogram_attr] !== ID;
            }));
          }

          updateFeatures(newSelected, newFullSelected, true);
        }
      });
    }
  });

  mapjs.getMapImpl().on('pointermove', (evt) => {
    if (flight() !== undefined) {
      const marks = mapjs.getLayers().filter((layer) => layer.name === CONFIGURATIONS.marks_name)[0];
      if (marks !== null && marks !== undefined) {
        marks.getFeatures().forEach((f) => {
          f.setStyle(new M.style.Polygon({
            fill: {
              color: '#0041ff',
              opacity: 0,
            },
          }));
        });
      }

      mapjs.getMapImpl().forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        if (marks !== null && marks !== undefined) {
          if (Utils.stringContainsString(feature.getGeometry().getType(), 'point')) {
            marks.getFeatures().forEach((f) => {
              if (f.getAttribute(CONFIGURATIONS.fotogram_attr) !== undefined) {
                if (f.getAttribute(CONFIGURATIONS.fotogram_attr) === feature.getProperties()[CONFIGURATIONS.fotogram_attr]) {
                  f.setStyle(new M.style.Polygon({
                    stroke: {
                      width: 2,
                      color: '#E74C3C',
                    },
                  }));
                } else {
                  f.setStyle(new M.style.Polygon({
                    fill: {
                      color: '#0041ff',
                      opacity: 0,
                    },
                  }));
                }
              }
            });
          } else {
            removeMapOverlays();
          }
        }
      });
    }
  });

  mapjs.getMapImpl().once('postrender', (evt) => {
    mapjs.removeControls('panzoom');
    unblock();
  });

	mapjs.addPlugin(new M.plugin.IGNSearchLocator({
			maxResults: 50,
			isCollapsed: true,
			collapsible: true,
		})
	);

	mapjs.addPlugin(new M.plugin.PrinterMap({
		position: 'TR',
	  collapsed: true,
	  collapsible: true,
	  tooltip: 'Imprimir mapa',
	  serverUrl: CONFIGURATIONS.print_url,
	  printTemplateUrl: `${CONFIGURATIONS.print_url}/print/IGEAR`,
	  printStatusUrl: `${CONFIGURATIONS.print_url}/print/status`,
		ckanUrl: CONFIGURATIONS.ckan_url,
	}));

	mapjs.addPlugin(new M.plugin.Rescale({
		collapsible: true,
		collapsed: true,
		position: 'BL',
		tooltip: 'Cambiar escala',
	}));

	mapjs.addPlugin(new M.plugin.ZoomPanel({
		position: 'TL',
		collapsed: true,
		collapsible: true,
		center: CENTER,
		zoom: initZoom,
	}));

	mapjs.addPlugin(new M.plugin.MeasureBar({
		position: 'TL',
		collapsible: true,
		collapsed: true,
		tooltip: 'Medidas',
	}));

	mapjs.addPlugin(new M.plugin.MouseSRS({
    tooltip: 'Coordenadas',
    srs: 'EPSG:25830',
    label: 'EPSG:25830',
    precision: 4,
    geoDecimalDigits: 5,
    utmDecimalDigits: 2,
  }));

	mapjs.addPlugin(new M.plugin.OverviewMap({
		position: 'BL',
		fixed: true,
		collapsed: true,
  	collapsible: true,
		zoom: 3,
		baseLayer: 'WMS*Overview*https://icearagon.aragon.es/Visor2D?*v_ign_lineas_limite_Fototeca_OverMap',
	}));

  const drawLayer = new M.layer.Vector({
    name: 'drawLayer',
    legend: 'drawLayer',
    extract: false,
  });

	mapjs.addPlugin(new M.plugin.BackImgLayer(getBackImgLayerConfiguration()));
	setTimeout(() => {
		M.proxy(false);
		mapjs.addLayers([drawLayer]);
		setTimeout(() => {
			M.proxy(true);
			drawLayer.setZIndex(99999999);
		}, 100);
	}, 500);
};

export const initCompareMap = (container, url, layerName, center, extent) => {
  let mapCompare = undefined;
	let layers = ['OSM'];
	const bit = document.querySelector('div#m-backimglayer-previews div.activeBackimglayerDiv').title;
	const filtered = getBackImgLayerConfiguration().layerOpts.filter((l) => {
		return l.title === bit;
	});

	if (filtered.length > 0) {
		layers = filtered[0].layers;
	}

	let initZoom = 5.8;
	if (window.innerHeight <= 907 && window.innerHeight >= 703) {
		initZoom = 5.4;
	} else if (window.innerHeight <= 702 && window.innerHeight > 620) {
		initZoom = 5.2;
	} else if (window.innerHeight <= 620 && window.innerHeight > 550) {
		initZoom = 5;
	} else if (window.innerHeight <= 550 && window.innerHeight > 485) {
		initZoom = 4.8;
	} else if (window.innerHeight <= 485 && window.innerHeight >= 485) {
		initZoom = 4.6;
	}

  if (extent.length > 2) {
		mapCompare = M.map({
			container: container,
			bbox: extent,
			layers,
			projection: `${PROJECTION}*m`,
			minZoom: initZoom,
			zoomConstrains: false,
		});
  } else {
		mapCompare = M.map({
			container: container,
			layers,
			center,
			projection: `${PROJECTION}*m`,
			zoom: initZoom,
			minZoom: initZoom,
			zoomConstrains: false,
		});
  }

  mapCompare.removeControls('panzoom');
	if (container.endsWith('0')) {
		mapCompare.addPlugin(new M.plugin.MeasureBar({
			position: 'TL',
			collapsible: true,
			collapsed: true,
			tooltip: 'Medidas',
		}));

		mapCompare.addPlugin(new M.plugin.ZoomPanel({
			position: 'TL',
			collapsed: true,
			collapsible: true,
			center,
			zoom: initZoom,
		}));
	}


  addCustomWMSLayerComparator(mapCompare, url, layerName);
  return mapCompare.getMapImpl();
}

export const initSwipeCompareMap = (container, url1, url2, layerName1, layerName2, center) => {
	let mapSwipeCompare = undefined;
	let layers = ['OSM'];
	const bit = document.querySelector('div#m-backimglayer-previews div.activeBackimglayerDiv').title;
	const filtered = getBackImgLayerConfiguration().layerOpts.filter((l) => {
		return l.title === bit;
	});

	if (filtered.length > 0) {
		layers = filtered[0].layers;
	}

	let initZoom = 5.8;
	if (window.innerHeight <= 907 && window.innerHeight >= 703) {
		initZoom = 5.4;
	} else if (window.innerHeight <= 702 && window.innerHeight > 620) {
		initZoom = 5.2;
	} else if (window.innerHeight <= 620 && window.innerHeight > 550) {
		initZoom = 5;
	} else if (window.innerHeight <= 550 && window.innerHeight > 485) {
		initZoom = 4.8;
	} else if (window.innerHeight <= 485 && window.innerHeight >= 485) {
		initZoom = 4.6;
	}

	mapSwipeCompare = M.map({
		container: container,
		layers,
		center,
		projection: `${PROJECTION}*m`,
		zoom: 12,
		minZoom: initZoom,
		zoomConstrains: false,
	});

  mapSwipeCompare.removeControls('panzoom');
	mapSwipeCompare.addPlugin(new M.plugin.MeasureBar({
		position: 'TL',
		collapsible: true,
		collapsed: true,
		tooltip: 'Medidas',
	}));

	mapSwipeCompare.addPlugin(new M.plugin.ZoomPanel({
		position: 'TL',
		collapsed: true,
		collapsible: true,
		center: CENTER,
		zoom: initZoom,
	}));

  const layer1 = addCustomWMSLayerComparator(mapSwipeCompare, url1, layerName1);
	const layer2 = addCustomWMSLayerComparator(mapSwipeCompare, url2, layerName2);
	const swipeControl = new ol.control.Swipe();
	mapSwipeCompare.getMapImpl().addControl(swipeControl);
	swipeControl.addLayer(layer1);
	swipeControl.addLayer(layer2, true);
  return mapSwipeCompare.getMapImpl();
}

export const initSpyCompareMap = (container, url1, url2, layerName1, layerName2, center) => {
	let mapSpyCompare = undefined;
	let layers = ['OSM'];
	const bit = document.querySelector('div#m-backimglayer-previews div.activeBackimglayerDiv').title;
	const filtered = getBackImgLayerConfiguration().layerOpts.filter((l) => {
		return l.title === bit;
	});

	if (filtered.length > 0) {
		layers = filtered[0].layers;
	}

	let initZoom = 5.8;
	if (window.innerHeight <= 907 && window.innerHeight >= 703) {
		initZoom = 5.4;
	} else if (window.innerHeight <= 702 && window.innerHeight > 620) {
		initZoom = 5.2;
	} else if (window.innerHeight <= 620 && window.innerHeight > 550) {
		initZoom = 5;
	} else if (window.innerHeight <= 550 && window.innerHeight > 485) {
		initZoom = 4.8;
	} else if (window.innerHeight <= 485 && window.innerHeight >= 485) {
		initZoom = 4.6;
	}

	mapSpyCompare = M.map({
		container: container,
		layers,
		center,
		projection: `${PROJECTION}*m`,
		zoom: 12,
		minZoom: initZoom,
		zoomConstrains: false,
	});

  mapSpyCompare.removeControls('panzoom');
	mapSpyCompare.addPlugin(new M.plugin.MeasureBar({
		position: 'TL',
		collapsible: true,
		collapsed: true,
		tooltip: 'Medidas',
	}));

	mapSpyCompare.addPlugin(new M.plugin.ZoomPanel({
		position: 'TL',
		collapsed: true,
		collapsible: true,
		center: CENTER,
		zoom: initZoom,
	}));

  addCustomWMSLayerComparator(mapSpyCompare, url1, layerName1);
	const layer = addCustomWMSLayerComparator(mapSpyCompare, url2, layerName2);
	const clipInteraction = new ClipInteraction({ radius: 100, layers: [layer] });
	mapSpyCompare.getMapImpl().addInteraction(clipInteraction);
  return mapSpyCompare.getMapImpl();
}

export const isLoadedMap = () => mapjs !== undefined;

export const getScale = () => {
  return mapjs.getScale();
}

export const getZoom = () => {
  return mapjs.getZoom();
}

export const getBbox = () => {
  const bbox = mapjs.getBbox();
  return [bbox.x.min, bbox.y.min, bbox.x.max, bbox.y.max];
}

export const setBbox = (extent) => {
  mapjs.setBbox(extent);
}

export const setBboxTransform = (coordinates) => {
  mapjs.setBbox(ol.proj.transformExtent(new ol.geom.Polygon(coordinates).getExtent(), 'EPSG:4326', PROJECTION));
}

export const toLonLat = (coords) => {
  return ol.proj.toLonLat(coords, PROJECTION);
}

export const extentIntersectsBbox = (extent) => {
  return ol.extent.intersects(getBbox(), extent);
}

export const getExtentByCoordinates = (geometry) => {
  let extent = [];
  if (geometry.type === 'Polygon') {
    extent = ol.proj.transformExtent(new ol.geom.Polygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  } else {
    extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  }

  return extent;
}

export const getCenterOfGeometry = (geometry) => {
  let extent = [];
  if (geometry.type === 'Polygon') {
    extent = ol.proj.transformExtent(new ol.geom.Polygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  } else {
    extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  }

  return ol.extent.getCenter(extent);
}

export const openInfoDialog = (text) => {
   M.dialog.info(text);
}

export const addWMSLayer = (name, legend, url, version, tiled, options) => {
  const args = {
    name: name,
    url: url,
    legend: legend,
    transparent: true,
    tiled: tiled,
    version: version,
  };

  const layer = new M.layer.WMS(args, options);
  if (options && options.hasOwnProperty('visibility')) {
    layer.setVisible(options.visibility);
  }

  if (options && options.hasOwnProperty('displayInLayerSwitcher')) {
    layer.displayInLayerSwitcher = options.displayInLayerSwitcher;
  }

  if (options && options.hasOwnProperty('zIndex')) {
    layer.setZIndex(options.zIndex);
  }

  mapjs.addLayers(layer);
  return layer.getImpl().getExtent();
};

export const addCustomWMSLayer = (url, layerName, unblock) => {
  if (!isCustomWMSLayerActive(layerName)) {
		const source = new ol.source.ImageWMS({
			url: url,
			params: {
				LAYERS: layerName,
				FORMAT: 'image/png',
				VERSION: '1.3.0',
				TRANSPARENT: true,
				ServiceName: layerName,
			},
			serverType: 'geoserver',
		});

		const layer = new ol.layer.Image({
			visible: true,
			opacity: 1,
			zIndex: 99999,
			source: source,
		});

    mapjs.getMapImpl().addLayer(layer);
    if (unblock !== undefined) {
      source.once('imageloadend', (evt) => {
        unblock();
      });

      source.once('imageloaderror', (evt) => {
        unblock();
      });
    }
  }
}

export const addCustomWMSLayerComparator = (map, url, layerName) => {
	const source = new ol.source.ImageWMS({
		url: url,
		params: {
			LAYERS: layerName,
			FORMAT: 'image/png',
			VERSION: '1.3.0',
			TRANSPARENT: true,
			ServiceName: layerName,
		},
		serverType: 'geoserver',
	});

	const layer = new ol.layer.Image({
		visible: true,
		opacity: 1,
		zIndex: 99999,
		source: source,
	});

  map.getMapImpl().addLayer(layer);
	return layer;
}

export const isCustomWMSLayerActive = (layerName) => {
  let res = false;
  const filtered = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.getSource() !== null && layer.getSource().params_ !== undefined && layer.getSource().getParams().ServiceName !== undefined && layer.getSource().getParams()['LAYERS'] === layerName;
  });

  res =  res || filtered.length > 0;
  return res;
}

export const setCustomWMSLayerOpacity = (layerName, newOpacity) => {
  const filtered = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.getSource() !== null && layer.getSource().params_ !== undefined && layer.getSource().getParams().ServiceName !== undefined && layer.getSource().getParams()['LAYERS'] === layerName;
  });

  filtered[0].setOpacity(newOpacity);
}

export const getCustomWMSLayerOpacity = (layerName) => {
  let res = 0;
  const filtered = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.getSource() !== null && layer.getSource().params_ !== undefined && layer.getSource().getParams().ServiceName !== undefined && layer.getSource().getParams()['LAYERS'] === layerName;
  });

  if (filtered.length > 0) {
    res = filtered[0].getOpacity();;
  }

  return res;
}

export const removeCustomWMSLayer = (layerName) => {
  const toDelete = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.getSource() !== null && layer.getSource().params_ !== undefined && layer.getSource().getParams().ServiceName !== undefined && layer.getSource().getParams()['LAYERS'] === layerName;
  });

  if (toDelete.length > 0) {
    mapjs.getMapImpl().removeLayer(toDelete[0]);
  }
}

export const removeAllCustomWMSLayer = () => {
  const toDelete = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.getSource() !== null && layer.getSource().params_ !== undefined && layer.getSource().getParams().ServiceName !== undefined;
  });

  if (toDelete.length > 0) {
    toDelete.forEach((del) => {
      mapjs.getMapImpl().removeLayer(del);
    });
  }
}

export const centerOnFotogram = (id, coordinates) => {
  const coord = ol.proj.fromLonLat(coordinates, PROJECTION);
  mapjs.setCenter(coord);
  mapjs.setZoom(CONFIGURATIONS.fotograms_zoom + 2);
}

export const newGeoJSONLayer = (args, options) => {
  return new M.layer.GeoJSON(args, options || {});
}

export const addFlightLayers = (coverage, centers, marks, getSelectedFeatures, unblock) => {
  removeMapOverlays();
  const zoom = mapjs.getZoom();
  const sourceCenters = Object.assign({}, centers.source);
  const sourceMarks = Object.assign({}, marks.source);
	mapjs.getMapImpl().un('moveend', simpleMoveEnd);
	if (moveEndEvent !== undefined) {
    ol.Observable.unByKey(moveEndEvent);
  }

	simpleMoveEnd();
  if (zoom >= CONFIGURATIONS.min_zoom && zoom <= CONFIGURATIONS.fotograms_zoom - 1) {
    if (!mapContainsLayer(coverage.name)) {
			removeCoverageLayer();
      mapjs.addLayers(coverage);
      coverage.setZIndex(999999);
      coverage.setStyle(new M.style.Polygon({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          width: 2,
          color: '#0041ff',
        },
      }));
    }
  } else {
    try {
      mapjs.removeLayers([coverage]);
			removeCoverageLayer();
    } catch (err) {}
  }

  if (zoom >= CONFIGURATIONS.fotograms_zoom && zoom <= CONFIGURATIONS.max_zoom) {
    mapjs.removeLayers([centers, marks]);
    const centersFeatures = sourceCenters.features.filter((f) => {
      return f.geometry !== null && ol.extent.containsCoordinate(getBbox(), ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION));
    });

    const marksFeatures = sourceMarks.features.filter((f) => {
      let extent = [];
      if (f.geometry !== null && f.geometry.type === 'Polygon') {
        extent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      } else if (f.geometry !== null) {
        extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      }

      return ol.extent.intersects(getBbox(), extent);
    });

    centers = newGeoJSONLayer({ source: Object.assign({}, sourceCenters), name: CONFIGURATIONS.centers_name, extract: false }, { displayInLayerSwitcher: false });
    marks = newGeoJSONLayer({ source: Object.assign({}, sourceMarks), name: CONFIGURATIONS.marks_name, extract: false }, { displayInLayerSwitcher: false });
    centers.source.features = centersFeatures;
    marks.source.features = marksFeatures;
    mapjs.addLayers(centers);
    mapjs.addLayers(marks);
    centers.setZIndex(1000000);
    marks.setZIndex(1000000);
    const pointStyle = new M.style.Point({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
      radius: 7,
    });

    centers.setStyle(pointStyle);
    marks.setStyle(new M.style.Polygon({
      fill: {
        color: '#0041ff',
        opacity: 0,
      },
    }));

    setTimeout(() => {
      centers.getFeatures().forEach((f) => {
        const selectedFeatures = getSelectedFeatures();
        if (selectedFeatures.indexOf(f.getAttribute(CONFIGURATIONS.fotogram_attr)) > -1) {
          f.setStyle(new M.style.Point({
            fill: {
              color: '#E74C3C',
              opacity: 0.6,
            },
            stroke: {
              color: '#E74C3C',
              width: 2,
            },
            radius: 7,
          }));
        }
      });
    }, CONFIGURATIONS.highlight_selected_timeout);
  } else {
    try {
      mapjs.removeLayers([centers, marks]);
    } catch (err) {}
  }

	moveEndEvent = mapjs.getMapImpl().on('moveend', complexMoveEnd.bind(null, coverage, centers, marks, sourceCenters, sourceMarks, getSelectedFeatures));
  mapjs.getMapImpl().once('postrender', (evt) => {
    unblock();
  });
}

export const addGeoJSONLayer = (args, options, geom, center, isMTN) => {
  const layer = new M.layer.GeoJSON(args, options || {});
  mapjs.addLayers(layer);
  if (Utils.stringContainsString(geom, 'Line')) {
    layer.setStyle(new M.style.Line({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
    }));
  } else if (Utils.stringContainsString(geom, 'Point')) {
    layer.setStyle(new M.style.Point({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
      radius: 7,
    }));
  } else if (Utils.stringContainsString(geom, 'Polygon')) {
    layer.setStyle(new M.style.Polygon({
      fill: {
        color: '#0041ff',
        opacity: isMTN ? 0.2 : 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
    }));
  }

  if (center) {
    setTimeout(() => {
      mapjs.setBbox(layer.getMaxExtent());
    }, CONFIGURATIONS.layer_added_timeout);
  }

  layer.setZIndex(99999999);
  return layer;
};

export const removeUploadedLayers = () => {
  let layerRes = mapjs.getLayers().filter((layer) => (layer.name.startsWith('uploadedLayer') || layer.name.startsWith('Hoja ')));
  if (layerRes && layerRes.length > 0) {
    return mapjs.removeLayers(layerRes);
  }

  return false;
};

export const mapContainsLayer = (layerName) => {
  let layerRes = mapjs.getLayers().filter((layer) => (layer.name === layerName));
  return layerRes && layerRes.length > 0;
}

export const removeAllFlightLayers = () => {
	mapjs.getMapImpl().un('moveend', simpleMoveEnd);
  if (moveEndEvent !== undefined) {
    ol.Observable.unByKey(moveEndEvent);
  }

  clearDrawLayer();
  removeAllCustomWMSLayer();
  const names = [CONFIGURATIONS.coverage_name, CONFIGURATIONS.centers_name, CONFIGURATIONS.marks_name];
  let layerRes = mapjs.getLayers().filter((layer) => {
    let res = false;
    names.forEach((name) => {
      res = res || layer.name.indexOf(name) > -1;
    });

    return res;
  });

	mapjs.getMapImpl().on('moveend', simpleMoveEnd);
  if (layerRes && layerRes.length > 0) {
    return mapjs.removeLayers(layerRes);
  }

  return false;
}

export const drawPolygon = (loadFeatures) => {
  removeDrawInteraction();
  clearDrawLayer();
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  const draw = new ol.interaction.Draw({
    source: drawLayer.getImpl().getOL3Layer().getSource(),
    type: 'Polygon',
    stopClick: true,
    style: new ol.style.Style({
      image: new ol.style.Circle({
          fill: new ol.style.Fill({
              color: '#478ffe',
          }),
          stroke: new ol.style.Stroke({
              width: 3,
              color: '#ffffff',
          }),
          radius: 6,
      }),
      fill: new ol.style.Fill({
        color: 'rgba(255, 255, 255, 0.5)'
      }),
      stroke: new ol.style.Stroke({
        color: EDITION_COLOR,
        width: 2,
      }),
    }),
  });

  mapjs.getMapImpl().addInteraction(draw);
  document.getElementById('map').style.cursor = 'crosshair';
  draw.once('drawend', (evt) => {
    setTimeout(() => {
      document.getElementById('map').style.cursor = 'default';
      loadFeatures();
      removeDrawInteraction();
    }, 100);
  });

  draw.once('drawstart', (evt) => {
    document.addEventListener('keydown', controlDrawWithKeyboard.bind(null, draw));
  });
}

export const hasDrawFeatures = () => {
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  return drawLayer.getImpl().getOL3Layer().getSource().getFeatures().length > 0;
}

export const clearDrawLayer = () => {
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  return drawLayer.clear();
}

export const getDrawnFeatures = () => {
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  return drawLayer.getImpl().getOL3Layer().getSource().getFeatures();
}

export const getUploadedLayer = () => {
  return mapjs.getLayers().filter((layer) => layer.name.startsWith('uploadedLayer'))[0];
}

export const removeDrawInteraction = () => {
  document.releaseEvents(Event.KEYDOWN);
  const arrayInteractions = [].concat(mapjs.getMapImpl().getInteractions().getArray());
  arrayInteractions.forEach((interaction) => {
    if (interaction instanceof ol.interaction.Draw || interaction instanceof ol.interaction.Modify) {
      mapjs.getMapImpl().removeInteraction(interaction);
    }
  });
}

export const isLayerIntersectingExtent = (layer, extent) => {
  let intersecting = false;
  for (let f of layer.features) {
    if (f.geometry.type === 'Point') {
      if (ol.extent.containsCoordinate(extent, ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION))) {
        intersecting = true;
        break;
      }
    } else if (f.geometry.type === 'Polygon') {
      const geom = new ol.geom.Polygon(f.geometry.coordinates);
      geom.transform('EPSG:4326', PROJECTION);
      if (geom.intersectsExtent(extent)) {
        intersecting = true;
        break;
      }
    } else if (f.geometry.type === 'MultiPolygon') {
      const geom = new ol.geom.MultiPolygon(f.geometry.coordinates);
      geom.transform('EPSG:4326', PROJECTION);
      if (geom.intersectsExtent(extent)) {
        intersecting = true;
        break;
      }
    }
  }

  return intersecting;
}

export const getFeaturesIntersectingExtent = (features, extent) => {
  let intersecting = [];
  features.forEach((f) => {
    if (f.geometry.type === 'Point') {
      if (ol.extent.containsCoordinate(extent, ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION))) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'Polygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(extent, featureExtent)) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'MultiPolygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(extent, featureExtent)) {
        intersecting.push(f);
      }
    }
  });

  return intersecting;
}

export const getFeaturesIntersectingGeometry = (features, geometry) => {
  let intersecting = [];
  features.forEach((f) => {
    if (f.geometry.type === 'Point') {
      if (geometry.getGeometry().intersectsCoordinate(ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION))) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'Polygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(geometry.getGeometry().getExtent(), featureExtent)) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'MultiPolygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(geometry.getGeometry().getExtent(), featureExtent)) {
        intersecting.push(f);
      }
    }
  });

  return intersecting;
}

export const addLayerFile = (file, block, unblock, t) => {
  block();
  const fileReader = new FileReader();
  fileReader.addEventListener('load', (e) => {
    try {
      let features = [];
      if ((file.type === 'application/vnd.google-earth.kml+xml') || Utils.checkFileExtension(file, '.kml')) {
        features = loadKMLLayer(mapjs.getLayers().length, fileReader.result, false);
      } else if (Utils.checkFileExtension(file, '.geojson') || Utils.checkFileExtension(file, '.json')) {
        features = loadGeoJSONLayer(mapjs.getLayers().length, fileReader.result);
      } else if (Utils.checkFileExtension(file, '.gpx')) {
        features = loadGPXLayer(mapjs.getLayers().length, fileReader.result);
      } else if (Utils.checkFileExtension(file, '.zip')) {
        const geojsonArray = [].concat(shp.parseZip(fileReader.result));
        geojsonArray.forEach((geojson) => {
          const localFeatures = loadGeoJSONLayer(mapjs.getLayers().length, geojson);
          if (localFeatures) {
            features = features.concat(localFeatures);
          }
        });
      } else {
        unblock(true);
        M.dialog.error(t('visor.wrong_format'));
      }

      if (!features.length) {
        unblock(true);
        M.dialog.info(t('visor.no_geom'));
      } else {
        if (features.length > CONFIGURATIONS.num_features_allowed) {
          unblock(true);
          M.dialog.info(t('visor.max_allowed1') + ' ' + CONFIGURATIONS.num_features_allowed + ' ' + t('visor.max_allowed2'));
        } else {
          let area = 0;
          features.forEach((f) => {
            if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
              area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
            }
          });

          if (area > CONFIGURATIONS.max_area_allowed)  {
            unblock(true);
            M.dialog.info(t('visor.area_limit'));
          } else {
            centerFeatures(features);
            unblock(false);
          }
        }
      }
    } catch (err) {
      unblock(true);
      M.dialog.error(t('visor.error_loading'));
    }
  });


  if (Utils.checkFileExtension(file, '.zip')) {
    fileReader.readAsArrayBuffer(file);
  } else if (Utils.checkFileExtension(file, '.kml') || Utils.checkFileExtension(file, '.gpx') || Utils.checkFileExtension(file, '.geojson') || Utils.checkFileExtension(file, '.json')) {
    fileReader.readAsText(file);
  } else {
    unblock();
    M.dialog.error(t('visor.wrong_format'));
  }
}

export const highlightFeatures = (selectedFeatures) => {
  const allFeatures = getRenderedCenters();
  allFeatures.forEach((f) => {
    if (selectedFeatures.indexOf(f.getAttribute(CONFIGURATIONS.fotogram_attr)) > -1) {
      f.setStyle(new M.style.Point({
        fill: {
          color: '#E74C3C',
          opacity: 0.6,
        },
        stroke: {
          color: '#E74C3C',
          width: 2,
        },
        radius: 7,
      }));
    } else {
      f.setStyle(new M.style.Point({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          color: '#0041ff',
          width: 2,
        },
        radius: 7,
      }));
    }
  });
}

const getRenderedCenters = () => {
  let res = [];
  let layerRes = mapjs.getLayers().filter((layer) => {
    return layer.name.indexOf(CONFIGURATIONS.centers_name) > -1;
  });

  if (layerRes.length > 0) {
    res = layerRes[0].getFeatures();
  }

  return res;
}

export const getFeatureFromFotogram = (fotogram, centersLayer) => {
  let res = null;
  const allFeatures = centersLayer.source.features;
  const filtered = allFeatures.filter((f) => {
    return f.properties[CONFIGURATIONS.fotogram_attr] === fotogram;
  });

  if (filtered.length > 0) {
    res = filtered[0];
  }

  return res;
}

export const getBackImgLayerConfiguration = (t) => {
	return {
		position: 'TR',
		collapsible: true,
		collapsed: true,
		layerId: 0,
		layerVisibility: true,
		columnsNumber: 5,
		layerOpts: [
			{
        id: 'topografico',
        preview: '/fototeca/img/layers/topo.png',
        title: 'Topográfico',
        layers: [
          new M.layer.WMTS({
            url: 'https://gestion4-idearagon.aragon.es/geoserver/gwc/service/wmts?',
            name: 'WMTS:AragonMapa',
            legend: 'WMTS:AragonMapa',
            matrixSet: 'EPSG25830_5000',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }, { crossOrigin: 'anonymous' }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'v_ign_lineas_limite_pol',
            legend: 'Lineas Limite',
            transparent: true,
            visible: true,
            format: 'image/png',
            version: '1.1.1',
          }),
        ],
      },
			{
        id: 'ortofoto',
        preview: '/fototeca/img/layers/ortofoto.png',
        title: 'Ortofoto',
        layers: [
          new M.layer.WMTS({
            url: 'https://gestion4-idearagon.aragon.es/geoserver/gwc/service/wmts?',
            name: 'WMTS:AragonFoto',
            legend: 'WMTS:AragonFoto',
            matrixSet: 'EPSG25830_5000',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'AraFon,Exonimos,v_ign_lineas_limite_pol,v101e_municipios_fotcar',
            legend: 'Límites y exónimos',
            transparent: true,
            visible: true,
						tiled: false,
            format: 'image/png',
            version: '1.1.1',
          }),
        ],
      },
			{
        id: 'osm',
        preview: '/fototeca/img/layers/osm.png',
        title: 'OpenStreetMap',
        layers: [
					new M.layer.OSM({
            name: 'osm',
            legend: 'OpenStreetMap',
            transparent: false,
						isBase: true,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'v_ign_lineas_limite_pol',
            legend: 'Lineas Limite',
            transparent: true,
            visible: true,
            format: 'image/png',
            version: '1.1.1',
          }),
        ],
      },
			{
        id: 'mdt',
        preview: '/fototeca/img/layers/mdt.png',
        title: 'MDT Sombreado',
        layers: [
					new M.layer.WMS({
            url: 'https://wmspro-idearagon.aragon.es/erdas-iws/ogc/wms/Modelos?',
            name: 'LiDAR_som_1m_2016_2021',
            legend: 'LiDAR_som_1m_2016_2021',
            transparent: true,
            visible: true,
						tiled: true,
            format: 'image/jpeg',
            version: '1.3.0',
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'AraFon,Exonimos,v_ign_lineas_limite_pol,v101e_municipios_fotcar',
            legend: 'Límites y exónimos',
            transparent: true,
            visible: true,
						tiled: false,
            format: 'image/png',
            version: '1.1.1',
          }),
        ],
      },
			{
        id: 'siose',
        preview: '/fototeca/img/layers/siose.png',
        title: 'Siose',
        layers: [
					new M.layer.WMTS({
            url: 'https://idearagon.aragon.es/geoserver/gwc/service/wmts?',
            name: 'WMTS:Siose_cobertura_2017',
            legend: 'WMTS:Siose_cobertura_2017',
            matrixSet: 'EPSG25830_10000',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'v_ign_lineas_limite_pol',
            legend: 'Lineas Limite',
            transparent: true,
            visible: true,
            format: 'image/png',
            version: '1.1.1',
          }),
        ],
      },
		],
	};
}

const removeCoverageLayer = () => {
  const layerRes = mapjs.getLayers().filter((layer) => {
    return layer.name.indexOf(CONFIGURATIONS.coverage_name) > -1;
  });

  if (layerRes && layerRes.length > 0) {
    return mapjs.removeLayers(layerRes);
  }

  return false;
}

const removeMapOverlays = () => {
  const overlays = mapjs.getMapImpl().getOverlays().getArray();
  overlays.forEach(item => {
    if (item.getKeys().indexOf('element') > -1 && item.element.innerHTML.indexOf('m-measure') < 0  && item.element.innerHTML.indexOf('ignsearchlocator') < 0) {
      mapjs.getMapImpl().removeOverlay(item);
    }
  });
}

const centerFeatures = (features) => {
  if (!M.utils.isNullOrEmpty(features)) {
    const extent = M.impl.utils.getFeaturesExtent(features);
    mapjs.getMapImpl().getView().fit(extent, {
      duration: 500,
      minResolution: 1,
    });
  }
}

const addVectorLayerFromFeatures = (layerName, features, type) => {
  if (type === 'uploaded') {
    layerName = 'uploadedLayer' + layerName;
  }

  const layer = new M.layer.Vector({ name: layerName }, { displayInLayerSwitcher: type === 'uploaded' ? true : false });
  layer.addFeatures(features);
  mapjs.addLayers(layer);
  layer.setZIndex(99999999);
  return layer;
}

const convertToMFeatures = (features) => {
  if (features instanceof Array) {
    return features.map((olFeature) => {
      const feature = new M.Feature(olFeature.getId(), {
        geometry: {
          coordinates: olFeature.getGeometry().getCoordinates(),
          type: olFeature.getGeometry().getType(),
        },
        properties: olFeature.getProperties(),
      });

      feature.getImpl().getOLFeature().setStyle(olFeature.getStyle());
      return feature;
    });
  }
}

const loadGeoJSONLayer = (layerName, source) => {
  let features = new ol.format.GeoJSON().readFeatures(source, { featureProjection: mapjs.getProjection().code });
  features.forEach((feature) => {
    const style1 = new ol.style.Style({
      stroke: new ol.style.Stroke({ color: '#0000FF', width: 8 }),
      fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
    });

    const style2 = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 6,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: '#7CFC00',
        }),
      }),
    });

    if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
      feature.setStyle(style1);
    } else {
      feature.setStyle(style2);
    }
  });

  features = convertToMFeatures(features);
  let area = 0;
  features.forEach((f) => {
    if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
      area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
    }
  });

  if (features.length > 0 && features.length <= CONFIGURATIONS.num_features_allowed && area <= CONFIGURATIONS.max_area_allowed) {
    addVectorLayerFromFeatures(layerName, features, 'uploaded');
  }

  return features;
}

const loadKMLLayer = (layerName, source, extractStyles) => {
  let features = new ol.format.KML({ extractStyles }).readFeatures(source, { featureProjection: mapjs.getProjection().code });
  features.forEach((feature) => {
    const style1 = new ol.style.Style({
      stroke: new ol.style.Stroke({ color: '#0000FF', width: 8 }),
      fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
    });

    const style2 = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 6,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: '#7CFC00',
        }),
      }),
    });

    if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
      feature.setStyle(style1);
    } else {
      feature.setStyle(style2);
    }
  });
  features = convertToMFeatures(features);
  let area = 0;
  features.forEach((f) => {
    if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
      area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
    }
  });

  if (features.length > 0 && features.length <= CONFIGURATIONS.num_features_allowed && area <= CONFIGURATIONS.max_area_allowed) {
    addVectorLayerFromFeatures(layerName, features, 'uploaded');
  }

  return features;
}

const loadGPXLayer = (layerName, source) => {
  let features = new ol.format.GPX().readFeatures(source, { featureProjection: mapjs.getProjection().code });
  features.forEach((feature) => {
    const style1 = new ol.style.Style({
      stroke: new ol.style.Stroke({ color: '#0000FF', width: 8 }),
      fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
    });

    const style2 = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 24,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: '#7CFC00',
        }),
      }),
    });

    if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
      feature.setStyle(style1);
    } else {
      feature.setStyle(style2);
    }
  });
  features = convertToMFeatures(features);
  let area = 0;
  features.forEach((f) => {
    if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
      area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
    }
  });

  if (features.length > 0 && features.length <= CONFIGURATIONS.num_features_allowed && area <= CONFIGURATIONS.max_area_allowed) {
    addVectorLayerFromFeatures(layerName, features, 'uploaded');
  }

  return features;
}

const controlDrawWithKeyboard = (draw, e) => {
  if (draw !== undefined && e !== undefined) {
    const key = e.keyCode || e.which;
    if (key === 27) {
      if (document.getElementById('drawPolygon').style.color === 'white') {
        document.getElementById('drawPolygon').click();
      }
    }

    if (key === 13) {
      draw.finishDrawing();
    }
  }
}

const simpleMoveEnd = () => {
  if (mapjs.getScale() > CONFIGURATIONS.tools_min_scale) {
    const arrayInteractions = [].concat(mapjs.getMapImpl().getInteractions().getArray());
    for (let interaction of arrayInteractions) {
      if (interaction instanceof ol.interaction.Draw) {
        if (interaction.getOverlay().getLayersArray().length > 0) {
          try {
            const color = interaction.getOverlay().getLayersArray()[0].getStyle().getStroke().getColor();
            if (Utils.compareStrings(color, EDITION_COLOR) === 0) {
              document.getElementById('drawPolygon').click();
              break;
            }
          } catch (err) { }
        }
      }
    }
  }
}

const complexMoveEnd = (coverage, centers, marks, sourceCenters, sourceMarks, getSelectedFeatures) => {
  const zoom = mapjs.getZoom();
  simpleMoveEnd();
	if (zoom >= CONFIGURATIONS.min_zoom && zoom <= CONFIGURATIONS.fotograms_zoom - 1) {
    removeMapOverlays();
    if (!mapContainsLayer(coverage.name)) {
			removeCoverageLayer();
      mapjs.addLayers(coverage);
      coverage.setZIndex(999999);
      coverage.setStyle(new M.style.Polygon({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          width: 2,
          color: '#0041ff',
        },
      }));
    }
  } else {
    try {
      mapjs.removeLayers([coverage]);
			removeCoverageLayer();
    } catch (err) {}
  }

	if (zoom >= CONFIGURATIONS.fotograms_zoom && zoom <= CONFIGURATIONS.max_zoom) {
    mapjs.removeLayers([centers, marks]);
    const centersFeatures = sourceCenters.features.filter((f) => {
      return f.geometry !== null && ol.extent.containsCoordinate(getBbox(), ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION));
    });

    const marksFeatures = sourceMarks.features.filter((f) => {
      let extent = [];
      if (f.geometry !== null && f.geometry.type === 'Polygon') {
        extent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      } else if (f.geometry !== null) {
        extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      }

      return ol.extent.intersects(getBbox(), extent);
    });

    centers = newGeoJSONLayer({ source: Object.assign({}, sourceCenters), name: CONFIGURATIONS.centers_name, extract: false }, { displayInLayerSwitcher: false });
    marks = newGeoJSONLayer({ source: Object.assign({}, sourceMarks), name: CONFIGURATIONS.marks_name, extract: false }, { displayInLayerSwitcher: false });
    centers.source.features = centersFeatures;
    marks.source.features = marksFeatures;
    mapjs.addLayers(centers);
    mapjs.addLayers(marks);
    centers.setZIndex(1000000);
    marks.setZIndex(1000000);
    const pointStyle = new M.style.Point({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
      radius: 7,
    });

    centers.setStyle(pointStyle);
    marks.setStyle(new M.style.Polygon({
      fill: {
        color: '#0041ff',
        opacity: 0,
      },
    }));

    setTimeout(() => {
      centers.getFeatures().forEach((f) => {
        const selectedFeatures = getSelectedFeatures();
        if (selectedFeatures.indexOf(f.getAttribute(CONFIGURATIONS.fotogram_attr)) > -1) {
          f.setStyle(new M.style.Point({
            fill: {
              color: '#E74C3C',
              opacity: 0.6,
            },
            stroke: {
              color: '#E74C3C',
              width: 2,
            },
            radius: 7,
          }));
        }
      });
    }, CONFIGURATIONS.highlight_selected_timeout);
  } else {
    try {
      mapjs.removeLayers([centers, marks]);
    } catch (err) {}
  }
}
